<template>
  <!-- 业务节点：处理人完成业务操作后，由引擎回调业务接口落库 -->
  <div class="" style="text-align: center">
    <el-form label-width="2.4rem">
      <el-form-item label="节点名称">
        <el-input v-model="nodeInfo.nodeName"/>
      </el-form-item>
      <el-form-item label="业务节点">
        <el-select v-if="businessNodes.length > 0" v-model="nodeInfo.businessId" placeholder="请选择业务节点">
          <el-option v-for="(s, i) in businessNodes" :key="i" :label="s.fieldLabel" :value="s.id"/>
        </el-select>
        <span v-else>该业务未配置业务节点，请先在「业务设置」中添加（类型选业务节点）</span>
      </el-form-item>
      <el-form-item label="回调接口" v-if="currentBusinessName">
        <span class="info-check-type">{{ currentBusinessName }}</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import customerComponentCheck from "./CustomerComponentCheck";
export default {
  props: {
    data: {
    },
    businessNodes: {default: () => []},
  },
  watch: {
    data: {
      handler() {
        this.init();
      }
    }
  },
  name: "",
  components: {
  },
  data() {
    return {
      nodeInfo: {
        businessServer: "",
        businessNode: "",
      },
      businessNodeList: [],
      // 业务表单功能的通用设置信息
      businessSetting: {

      },
    };
  },
  created() {
    this.init();
  },
  computed: {
    // 当前选中业务节点对应的回调接口，展示出来便于核对
    currentBusinessName() {
      const hit = this.businessNodes.find(n => n.id === this.nodeInfo.businessId);
      return hit ? hit.fieldName : "";
    },
  },
  methods: {
    init() {
      // 解析字符串
      let params = this.data.businessParams ? JSON.parse(this.data.businessParams) : {};
      this.nodeInfo = {
        ...this.data,
        businessId: params.nodeId
      }
    },
    // 返回数据，并进行验证
    getData() {
      // 业务相关的参数，转成json字符串
      let params = {
        nodeId: this.nodeInfo.businessId
      }
      // 设置一个message，用于绘图显示在页面上
      let message = "";
      for (let i = 0; i < this.businessNodes.length; i++) {
        if (this.businessNodes[i].id === this.nodeInfo.businessId) {
          message = this.businessNodes[i].fieldLabel;
          break;
        }
      }
      let data = {
        ...this.nodeInfo,
        message,
        businessParams: JSON.stringify(params),
        properties: {
          businessParams: JSON.stringify(params),
        },
      };
      // 数据验证
      let errorMessage = customerComponentCheck.businessNodeValid(data);
      if (errorMessage) {
        this.$message.error(errorMessage);
        throw new Error(errorMessage);
      }
      return data;
    },
  }
};
</script>

<style lang="scss" scoped>

</style>